import { getLocale } from '../storageService/GlobalData';

export default () => {
  if (getLocale() === 'en') {
    return '1';
  } else {
    return '2';
  }
};
